export type DocumentGroup =
    | 'PENDING'
    | 'HR_CULTURE'
    | 'PROCEDURE_GUIDE'
    | 'LEGAL_ADMIN'

export const DocumentGroupPending: DocumentGroup = 'PENDING'
export const DocumentGroupHrCulture: DocumentGroup = 'HR_CULTURE'
export const DocumentGroupProcedureGuide: DocumentGroup = 'PROCEDURE_GUIDE'
export const DocumentGroupLegalAdmin: DocumentGroup = 'LEGAL_ADMIN'

export const DOCUMENT_GROUPS = [
    { value: DocumentGroupHrCulture, label: 'HR & Culture' },
    { value: DocumentGroupProcedureGuide, label: 'Procedure Guide' },
    { value: DocumentGroupLegalAdmin, label: 'Legal & Admin' },
    { value: DocumentGroupPending, label: 'Pending' },
]

export type DocumentType =
    | 'POLICY'
    | 'INTERNAL_RULE'
    | 'REGULATION'
    | 'GUIDELINE'
    | 'FORM'
    | 'OBJECTIVE'
    | 'ANNOUNCEMENT'
    | 'PLAN'
    | 'REPORT'
    | 'MINUTES'
    | 'DECISION'
    | 'LICENSE_CERTIFICATE'
    | 'PENDING'

export const DocumentTypePolicy: DocumentType = 'POLICY'
export const DocumentTypeInternalRule: DocumentType = 'INTERNAL_RULE'
export const DocumentTypeRegulation: DocumentType = 'REGULATION'
export const DocumentTypeGuideline: DocumentType = 'GUIDELINE'
export const DocumentTypeForm: DocumentType = 'FORM'
export const DocumentTypeObjective: DocumentType = 'OBJECTIVE'
export const DocumentTypeAnnouncement: DocumentType = 'ANNOUNCEMENT'
export const DocumentTypePlan: DocumentType = 'PLAN'
export const DocumentTypeReport: DocumentType = 'REPORT'
export const DocumentTypeMinutes: DocumentType = 'MINUTES'
export const DocumentTypeDecision: DocumentType = 'DECISION'
export const DocumentTypeLicenseCertificate: DocumentType =
    'LICENSE_CERTIFICATE'
export const DocumentTypePending: DocumentType = 'PENDING'

export const DOCUMENT_TYPES = [
    { value: DocumentTypePolicy, label: 'Policy' },
    { value: DocumentTypeInternalRule, label: 'Internal Rule' },
    { value: DocumentTypeRegulation, label: 'Regulation' },
    { value: DocumentTypeGuideline, label: 'Guideline' },
    { value: DocumentTypeForm, label: 'Form' },
    { value: DocumentTypeObjective, label: 'Objective' },
    { value: DocumentTypeAnnouncement, label: 'Announcement' },
    { value: DocumentTypePlan, label: 'Plan' },
    { value: DocumentTypeReport, label: 'Report' },
    { value: DocumentTypeMinutes, label: 'Minutes' },
    { value: DocumentTypeDecision, label: 'Decision' },
    { value: DocumentTypeLicenseCertificate, label: 'License & Certificate' },
    { value: DocumentTypePending, label: 'Pending' },
]

export type ConfidentialityLevel =
    | 'PENDING'
    | 'INTERNAL'
    | 'RESTRICTED'
    | 'TOP_SECRET'

export const ConfidentialityLevelPending: ConfidentialityLevel = 'PENDING'
export const ConfidentialityLevelInternal: ConfidentialityLevel = 'INTERNAL'
export const ConfidentialityLevelRestricted: ConfidentialityLevel = 'RESTRICTED'
export const ConfidentialityLevelTopSecret: ConfidentialityLevel = 'TOP_SECRET'

export const CONFIDENTIALITY_LEVELS = [
    { value: ConfidentialityLevelPending, label: 'Pending' },
    { value: ConfidentialityLevelInternal, label: 'Internal' },
    { value: ConfidentialityLevelRestricted, label: 'Restricted' },
    { value: ConfidentialityLevelTopSecret, label: 'Top Secret' },
]

export type IntegrityLevel = 'PENDING' | 'LOW' | 'MEDIUM' | 'HIGH'

export const IntegrityLevelPending: IntegrityLevel = 'PENDING'
export const IntegrityLevelLow: IntegrityLevel = 'LOW'
export const IntegrityLevelMedium: IntegrityLevel = 'MEDIUM'
export const IntegrityLevelHigh: IntegrityLevel = 'HIGH'

export const INTEGRITY_LEVELS = [
    { value: IntegrityLevelPending, label: 'Pending' },
    { value: IntegrityLevelLow, label: 'Low' },
    { value: IntegrityLevelMedium, label: 'Medium' },
    { value: IntegrityLevelHigh, label: 'High' },
]

export type AvailabilityLevel = 'PENDING' | 'LOW' | 'MEDIUM' | 'HIGH'

export const AvailabilityLevelPending: AvailabilityLevel = 'PENDING'
export const AvailabilityLevelLow: AvailabilityLevel = 'LOW'
export const AvailabilityLevelMedium: AvailabilityLevel = 'MEDIUM'
export const AvailabilityLevelHigh: AvailabilityLevel = 'HIGH'

export const AVAILABILITY_LEVELS = [
    { value: AvailabilityLevelPending, label: 'Pending' },
    { value: AvailabilityLevelLow, label: 'Low' },
    { value: AvailabilityLevelMedium, label: 'Medium' },
    { value: AvailabilityLevelHigh, label: 'High' },
]

export type Status =
    | 'DRAFT'
    | 'PENDING'
    | 'REJECTED'
    | 'PUBLISHED'
    | 'ARCHIVED'
    | 'PROCESSING'

export const StatusDraft: Status = 'DRAFT'
export const StatusPending: Status = 'PENDING'
export const StatusRejected: Status = 'REJECTED'
export const StatusPublished: Status = 'PUBLISHED'
export const StatusArchived: Status = 'ARCHIVED'
export const StatusProcessing: Status = 'PROCESSING'

export const DOCUMENT_GROUP_TO_TYPES: Record<DocumentGroup, DocumentType[]> = {
    [DocumentGroupPending]: [],
    [DocumentGroupHrCulture]: [
        DocumentTypePolicy,
        DocumentTypeReport,
        DocumentTypeMinutes,
        DocumentTypeAnnouncement,
        DocumentTypePlan,
        DocumentTypeObjective,
    ],
    [DocumentGroupProcedureGuide]: [
        DocumentTypeInternalRule,
        DocumentTypeRegulation,
        DocumentTypeGuideline,
        DocumentTypeForm,
    ],
    [DocumentGroupLegalAdmin]: [
        DocumentTypeDecision,
        DocumentTypeLicenseCertificate,
    ],
}

export const DOCUMENT_TYPE_TO_GROUP: Record<DocumentType, DocumentGroup> =
    Object.entries(DOCUMENT_GROUP_TO_TYPES).reduce(
        (acc, [group, types]) => {
            types.forEach((type) => {
                acc[type] = group as DocumentGroup
            })
            return acc
        },
        {} as Record<DocumentType, DocumentGroup>
    )
